import { isISODate } from 'lib/helpers/asISODate/asISODate'
import { formatDateToISO } from 'lib/helpers/formatDateToISO/formatDateToISO'
import { parseDateFromISO } from 'lib/helpers/parseDateFromISO/parseDateFromISO'
import { toUtcWallClock } from 'lib/helpers/toUtcWallClock/toUtcWallClock'

/** The only sanctioned crossing for schema fields declared ISO8601DateTime whose value is a calendar date. */
export const toMistypedDateTime = (date: Maybe<ISODate>) => date as unknown as Maybe<ISODateTime>

/** The server serializes such a day as a timestamp at its UTC midnight, so a timestamp reads as its UTC day. */
export const fromMistypedDateTime = (date: Maybe<ISODateTime>): Maybe<ISODate> => {
  if (!date) {
    return null
  }

  if (isISODate(date)) {
    return date
  }

  const instant = parseDateFromISO(date)

  return instant ? formatDateToISO(toUtcWallClock(instant)) : null
}
